/* jshint esnext:true */
/* global document */ // safe checked

const cookie = require('cookie');

// we intentionally do not cache the result of this function
// while it's true that the value should not change
// during a page's lifetime, if the user does something
// in an another tab, then it can change
// so it is safer to calculate it every time

export function csrfToken() {
    const token = cookie.parse(document.cookie).csrftoken;
    if (!token) {
        throw new Error('csrfToken: unable to find token');
    }

    return token;
}
